module.exports = __webpack_public_path__ + "static/media/22829788_1638428612898990_593416434566992687_o.6a1aa729.jpg";